import { create } from 'zustand';
import type { Route } from '../../lib/db.js';

interface FollowRouteState {
  route: Route | null;
  activeLeg: number; // index of the leg's *destination* waypoint (1..n-1)
  start: (route: Route) => void;
  stop: () => void;
  setActiveLeg: (i: number) => void;
}

/** The route currently being followed on the Naviger screen (spec 05). */
export const useFollowStore = create<FollowRouteState>((set) => ({
  route: null,
  activeLeg: 1,
  start: (route) => set({ route, activeLeg: 1 }),
  stop: () => set({ route: null, activeLeg: 1 }),
  setActiveLeg: (activeLeg) => set({ activeLeg }),
}));
